define('shoptheme/components/ui/sidebar',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire"
], function(
	$,
	_,
	Component,
	BEM,
	BreakPoints,
	enquire
) {
	var instances = [];
	var isMobile = true;

	var TRANSITION_DURATION = 250;

	enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
		match: function() {
			isMobile = false;

			_.forEach(instances, function(instance) {
				instance.desktop();
			});
		},
		unmatch: function() {
			isMobile = true;

			_.forEach(instances, function(instance) {
				instance.mobile();
			});
		}
	}, true);

	return Component.create({
		block: null,
		triggerBlock: null,
		productList: null,
		isOpen: false,
		isBuilt: false,
		backdrop: null,
		closeBlock: null,

		$init: function() {
			this.block = $("." + BEM.buildElementClassname('main-container', 'col2-left-col-left'));
			this.productList = BEM.block("product-list");

			instances.push(this);

			if (isMobile) {
				this.mobile();
			}
		},

		desktop: function() {
			if (!this.isBuilt) return;
			this.triggerBlock.css("display", "none");
			this.close(true);
		},

		mobile: function() {
			this.mobile = this.buildMobile()
				? function() {
					this.triggerBlock.css("display", "");
				}
				: $.noop;
		},

		toggle: function() {
			this[this.isOpen ? 'close' : 'open']();
		},

		open: function() {
			this.block.bemAddModifier("open");
			this.backdrop.appendTo(document.body);

			if ($.support.transition) {
				this.block
					.one('bsTransitionEnd', _.bind(this.onOpened, this))
					.emulateTransitionEnd(TRANSITION_DURATION);

				$({foo:0}).animate({foo:50}, {
					step: _.bind(function(val) {
						this.backdrop.css("opacity", val / 100);
					}, this)
				}, TRANSITION_DURATION);
			} else {
				this.onOpened();
			}
		},

		onOpened: function() {
			this.isOpen = true;
		},

		close: function(immediately) {
			immediately = !!immediately;
			this.block.bemRemoveModifier("open");

			if (!immediately && $.support.transition) {
				this.block
					.one('bsTransitionEnd', _.bind(this.onClosed, this))
					.emulateTransitionEnd(TRANSITION_DURATION);

				$({foo: this.backdrop.css("opacity") * 100 }).animate({foo: 0}, {
					step: _.bind(function(val) {
						this.backdrop.css("opacity", val / 100);
					}, this)
				}, TRANSITION_DURATION);
			} else {
				this.onClosed();
			}
		},

		onClosed: function() {
			this.isOpen = false;
			this.backdrop.detach();
		},

		buildMobile: function() {
			if (!this.productList.length) return false;

			var layeredNav = BEM.block('layered-nav'),
				titles = layeredNav.getElements('filter-title'),
				filterCount = titles.length;

			if (!filterCount) return false;

			this.triggerBlock = BEM.block($('<div class="' + BEM.buildBlockClassname('sidebar-trigger') + '" />'));
			this.triggerBlock.on("click", _.bind(this.toggle, this));

			this.backdrop = $('<div class="modal-backdrop in" />');
			this.backdrop.on("click", _.bind(this.close, this));

			this.closeBlock = BEM.block($('<div class="' + BEM.buildBlockClassname('sidebar-close') + '" />'));
			this.closeBlock.on("click", _.bind(this.close, this));
			this.closeBlock.prependTo(this.block);

			$('<span class="' + BEM.buildElementClassname('sidebar-trigger', 'title') + '" />')
				.text(window.Translator.translate("Show filters"))
				.appendTo(this.triggerBlock);

			$('<span class="' + BEM.buildElementClassname('sidebar-trigger', 'count') + '" />')
				.text('(' + filterCount + ')')
				.appendTo(this.triggerBlock);

			this.productList.before(this.triggerBlock);

			this.isBuilt = true;

			return true;
		}
	});
});

